<template>
    <modal name="createModal" transition="pop-out" :width="modalWidth" :height="300">
        <div class="modal__header">
            <h4>Add New Requirement</h4>
        </div>
        <div class="cas_input">
            <div class="row__wrapper">
                <div class="row">
                    <div class="col-md-12">
                        <div class="input_wrapper" style="">
                            <span>Requirement Name</span>
                            <div class="">
                                <input type="text" placeholder="Enter Requirement name" class="ml-3" v-model="requirementName" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row mt-2">
                    <div class="col-md-12">
                        <div class="input_wrapper" style="">
                            <span>Requirement Type</span>
                            <div class="">
                                <select v-model="requirementType">
                                    <option value="">Select Requirement Type</option>
                                    <option v-for="val in requirementTypes" v-bind:key="val.id" v-bind:value="val.id">{{val.typeName}}</option>
                                </select>
                                
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            
            <div class="text-center mt-4">
                <button class="creaet_branch_btn"
                    @click="validateDetails($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                    isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' }
                    ]">
                    Add Requirement
                    <span class="">
                        <img src="@/assets/img/git_loader.gif" v-if="showLoader"  width="25px"/>
                    </span>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
const MODAL_WIDTH = 500;
import configObject from "@/config";


export default {
    name: 'createModal',
    data(){
        return{
            showLoader: false,
            //requirementTypes: [],
            requirementName: null,
            //requirementType: null,
            isButtonDisabled:  false,
        }
    },
    created () {
        this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH

        console.log(this.$store.getters.getBranchdetails);
        
    },
    mounted(){
        //this.getTypes();
    },
    methods: {
        // getTypes(){
        //     this.axios.get(`${configObject.apiBaseUrl}/Requirement/Types`, configObject.authConfig)
        //     .then(resp => {
        //         console.log(resp.data);
        //         this.requirementTypes = resp.data;
        //     })
        //     .catch(error => {
        //         this.$toast.open({
        //             message: "An Error Occured",
        //             type: "error",
        //             duration: 4000
        //         });
        //         console.log(error);
        //     })
        // },
        validateDetails($event){
            $event.preventDefault();
            if(!this.requirementName){
                this.$toasted.show("Fill in the missing Fields", {
                        theme: "bubble",
                        position: "top-center",
                        duration: 4000
                    });
            }else {
                this.createRequirement();
            }
        },
        createRequirement(){
            this.isButtonDisabled = true;
            this.showLoader = true;
            let data = {
                task: this.requirementName,
                deleted: false
            }
            console.log(data);

            this.axios.post(`${configObject.apiBaseUrl}/Requirement/Add`, data, configObject.authConfig)
            .then(resp => {
                this.isButtonDisabled = false;
                this.showLoader = false;
                console.log(resp.data);
                this.$toast.success("Requirement created successfully");
                this.closeModal();
                this.$eventHub.$emit("refreshRequirementTable");
            })
            .catch(error => {
                this.isButtonDisabled = false;
                this.showLoader = false;
                this.$toast.open({
                    message: "unable to create requirement",
                    type: "error",
                    duration: 4000
                });
                console.log(error);
            })
        },
        closeModal(){
            this.$modal.hide('createModal');
        }
    }
}
</script>